import React from "react";
import CountUp from "react-countup";

const FunFact = (props) => {
  return (
    <section className={"" + props.hclass} style={{ marginTop: "100px" }}>
      <div className="container">
        <div className="row">
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={10000} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Attendees</h4>
            </div>
          </div>
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={21} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Countries</h4>
            </div>
          </div>
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={100} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Success Stories</h4>
            </div>
          </div>
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={32} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Awards Winner</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunFact;
